import React from 'react';

export default function AudiosIcon({ width = 28, height = 28, fill = '#FE5442', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.75 9.0367L16.25 6.48669V11.4784C15.6233 11.0076 14.8442 10.7287 14 10.7287C11.9289 10.7287 10.25 12.4076 10.25 14.4787C10.25 16.5497 11.9289 18.2287 14 18.2287C16.0711 18.2287 17.75 16.5497 17.75 14.4787V2.47867C17.75 0.980227 16.3001 -0.0906701 14.8679 0.350007L10.2867 1.75961L8.2445 2.34308C7.0639 2.68039 6.25 3.75945 6.25 4.98727V14.4784C5.62325 14.0076 4.8442 13.7287 4 13.7287C1.92893 13.7287 0.25 15.4076 0.25 17.4787C0.25 19.5497 1.92893 21.2287 4 21.2287C6.07107 21.2287 7.75 19.5497 7.75 17.4787V9.0367ZM15.309 1.78367C15.7766 1.6398 16.25 1.98944 16.25 2.47867V4.92065L7.75 7.47064V4.98727C7.75 4.42917 8.12 3.93869 8.6566 3.78537L10.7133 3.19773L15.309 1.78367ZM14 12.2287C15.2426 12.2287 16.25 13.236 16.25 14.4787C16.25 15.7213 15.2426 16.7287 14 16.7287C12.7574 16.7287 11.75 15.7213 11.75 14.4787C11.75 13.236 12.7574 12.2287 14 12.2287ZM4 15.2287C5.24264 15.2287 6.25 16.236 6.25 17.4787C6.25 18.7213 5.24264 19.7287 4 19.7287C2.75736 19.7287 1.75 18.7213 1.75 17.4787C1.75 16.236 2.75736 15.2287 4 15.2287Z"
        fill={fill}
      />
    </svg>
  );
}
